import { render, staticRenderFns } from "./LegalInformationsConfig.vue?vue&type=template&id=ec7df064&scoped=true"
import script from "./LegalInformationsConfig.vue?vue&type=script&lang=js"
export * from "./LegalInformationsConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec7df064",
  null
  
)

export default component.exports